import { render, staticRenderFns } from "./DialogAnexos.vue?vue&type=template&id=97969378&scoped=true"
import script from "./DialogAnexos.vue?vue&type=script&lang=js"
export * from "./DialogAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97969378",
  null
  
)

export default component.exports